module.exports = __webpack_public_path__ + "static/linkedin-logo-ce09a3ffe0ae50ca9f59219d3597d234.png";